import { Incarico } from './incarico';
import { Model } from './model';
import { StimaDannoPeriziaUniversale } from './stima-danno-perizia-universale';
import { AllegatoPeriziaUniversale } from './allegato-perizia-universale';

export class PeriziaUniversale extends Model {
  static apiUrl: string = "perizie_universali";

  incarico: Incarico;

  pagamento_del_premio: string;
  esistenza_di_vincoli: string;
  coassicurazioni_indirette: string;
  sinistri_precedenti: string;
  ubicazione_descrizione_rischio: string;
  mezzi_chiusura: string;
  causa_descrizione_sinistro: string;
  riassunto_danni: string;
  riserve_indennizzo: string;
  impressioni_perito_condizioni_rischio: string;
  note: string;
  localita_e_data: string;

  stime_danno: StimaDannoPeriziaUniversale[];
  allegati: AllegatoPeriziaUniversale[];

  deserialize(input: any): PeriziaUniversale {
    let retV: PeriziaUniversale = new PeriziaUniversale();

    retV = super.deserialize(input) as PeriziaUniversale;

    if (input?.incarico) {
      retV.incarico = new Incarico().deserialize(input.incarico);
    }

    if (input?.stime_danno) {
      retV.stime_danno = input.stime_danno.map(v => new StimaDannoPeriziaUniversale().deserialize(v));
    }
    if (input?.allegati) {
      retV.allegati = input.allegati.map(v => new AllegatoPeriziaUniversale().deserialize(v));
    }


    return retV;
  }

}
